// R0112:
// IF /TransitOperation/security is in SET {1, 3}
// THEN phone numbers must have an international phone number format as defined
// in ITU-T recommendation E.123 (02/2001), compliant with the pattern "^\+(?:[0-9] ?){6,14}[0-9]$"
const INTERNATIONAL_PHONE_NUMBER_PATTERN = /^\+(?:[0-9] ?){6,14}[0-9]$/

export const R0112_ERROR_MESSAGE = 'Phone number must be in international format, e.g. +372 51234567'

const R0112Validator = {
  appliesTo: (security: string): boolean => ['1', '3'].includes(security),
  isValidInternationalPhoneNumber: (phoneNumber: string): boolean => INTERNATIONAL_PHONE_NUMBER_PATTERN.test(phoneNumber),
} as const

export default R0112Validator
